import { TranslationGroup } from '../i18n/tanslation-group';
import { identityConstants } from './identity-constants';
import { en } from './i18n/en';
import { zh } from './i18n/zh';

export const mmIdentityTranslationGroup = {
    groupName: identityConstants.transalationGroup,
    translations: {
        "en": en,
        "zh": zh
    }
} as TranslationGroup;